<template lang="pug">
GenericCard.unix-print-panel(size='40')
  .d-flex.flex-column.px-4.py-4
    .text-large
      | พิมพ์รายการขายส่งเข้า UNIX
    CustomDatePickerSingle.mt-3.mx-auto(
      v-model='selectedDate'
    )

    .d-flex.justify-content-center.mt-3
      button.btn.btn-upa-secondary.px-3(
        @click='downloadPDF'
      )
        i.fa.fa-print.mr-1
        | พิมพ์

      //- Removed as Backend said it doesn't exists
      //- button.btn.btn-upa-secondary.ml-2.px-3(
      //-   @click='downloadXLS'
      //- )
      //-   i.fa.fa-download.mr-1
      //-   | ดาวโหลดเป็น .xls

  //- hr.m-0.w-100
  //- .d-flex.flex-column
  //-   template(v-if='error')
  //-     .text-center.text-medium.red.p-3
  //-       | {{ error }}
  //-   template(v-else-if='success')
  //-     //- .alert.alert-success
  //-     .text-center.text-medium.p-3
  //-       img.mr-2(src='@/assets/icons/success.svg' width='20px')
  //-       | ดาวโหลดไฟล์สำเร็จ
</template>

<script>
export default {
  data() {
    return {
      selectedDate: this.$moment().startOf('day').toDate(),

      // error: null,
      // success: false,
    };
  },
  computed: {
    urlForPDF() {
      return this.$api.admin.report.unixReportURL(
        this.selectedDate,
      );
    },
    urlForXLS() {
      return this.$api.admin.report.unixExcelURL(
        this.selectedDate,
      );
    },
  },
  methods: {
    async downloadPDF() {
      window.open(this.urlForPDF);
    },
    async downloadXLS() {
      window.open(this.urlForXLS);
    },
  },
};
</script>

<style lang="scss">
// .line-api-panel {}
</style>
